/**
 * Header decoration/icon for a preference type category.
 *
 * Belongs here: header SVG or fund list UI.
 * Does not belong here: questionnaire flow.
 */
export function SatellitePreferenceHeaderIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="160"
      viewBox="0 0 130 160"
      fill="none"
      className={className}
      aria-hidden
    >
      <g clipPath="url(#clip0_99328_278966)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.842 25.069C117.461 25.8364 116.05 26.6542 114.61 27.5211C117.497 29.4286 120.217 31.5678 122.744 33.9123C114.079 48.4947 100.369 65.9068 83.138 83.138C65.9068 100.369 48.4947 114.079 33.9123 122.744C31.5678 120.217 29.4285 117.497 27.5211 114.61C26.6542 116.05 25.8364 117.461 25.069 118.842C20.8445 126.446 18.3972 132.69 17.512 137.26C16.822 140.824 17.2631 142.219 17.4207 142.579C17.7808 142.737 19.1763 143.178 22.7396 142.488C27.31 141.603 33.5535 139.155 41.1574 134.931C42.5388 134.163 43.9506 133.346 45.3898 132.478C45.3846 132.475 45.3795 132.472 45.3744 132.468C60.2373 123.064 76.9487 109.53 93.2395 93.2395C109.53 76.9487 123.064 60.2373 132.468 45.3744C132.472 45.3795 132.475 45.3846 132.478 45.3898C133.346 43.9506 134.163 42.5388 134.931 41.1574C139.155 33.5535 141.603 27.31 142.488 22.7396C143.178 19.1763 142.737 17.7808 142.579 17.4207C142.219 17.2631 140.824 16.822 137.26 17.512C132.69 18.3972 126.446 20.8445 118.842 25.069ZM140.818 64.0574C144.286 59.0133 147.336 54.1287 149.916 49.4827C154.568 41.111 157.948 33.0718 159.318 25.999C160.619 19.2807 160.508 11.061 154.723 5.27638C148.939 -0.508197 140.72 -0.619231 134.001 0.681913C126.928 2.0517 118.889 5.43244 110.517 10.0834C105.871 12.6644 100.987 15.7135 95.9429 19.1821C90.8513 17.8511 85.5083 17.1424 79.9996 17.1424C45.2845 17.1424 17.1424 45.2845 17.1424 79.9996C17.1424 85.5083 17.8511 90.8513 19.1821 95.9429C15.7135 100.987 12.6644 105.871 10.0834 110.517C5.43244 118.889 2.0517 126.928 0.681913 134.001C-0.619231 140.72 -0.508197 148.939 5.27638 154.723C11.061 160.508 19.2807 160.619 25.999 159.318C33.0718 157.948 41.111 154.568 49.4827 149.916C54.1287 147.336 59.0133 144.286 64.0574 140.818C69.1486 142.148 74.4912 142.857 79.9996 142.857C114.715 142.857 142.857 114.715 142.857 79.9996C142.857 74.4912 142.148 69.1486 140.818 64.0574Z"
          fill="#E2B0A7"
        />
      </g>
      <defs>
        <clipPath id="clip0_99328_278966">
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
